export default "__VITE_ASSET__6e14e94a__"